import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=9a150fca&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a150fca')) {
      api.createRecord('9a150fca', component.options)
    } else {
      api.reload('9a150fca', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=9a150fca&", function () {
      api.rerender('9a150fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/pagination.vue"
export default component.exports